// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"a36aee9f","2495":"8337604a","6572":"8337604a","7716":"f524e22f","8440":"8337604a","9338":"2a47db1d"}[chunkId] + ".chunk.css";
};